import { HttpClient, HttpBackend } from '@angular/common/http';
import { ApiAuthInterceptor } from 'app/http/interceptors/api-auth.interceptor';
import { ApiUrlInterceptor } from 'app/http/interceptors/api-url.interceptor';
import { ApiHttpHandler } from 'app/http/handler';
import { Injectable } from '@angular/core';
import { ApiResponseInterceptor } from 'app/http/interceptors/api-response.interceptor';
import { Cookie } from 'ng2-cookies';
import { environment } from 'environments/environment';
import { Location } from '@angular/common';

@Injectable()
export class ApiHttpClient extends HttpClient {
    constructor(backend: HttpBackend, location: Location) {
        super(new ApiHttpHandler(backend, [
            new ApiAuthInterceptor(),
            new ApiUrlInterceptor(environment.API_URL),
            new ApiResponseInterceptor(location)
        ]));
    }

    postSync(url: string, body: any): void {
        const apiUrl = environment.API_URL + url;
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.open('POST', apiUrl, false);
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Cookie.get('auth_token'));
        xmlHttp.setRequestHeader('Content-type', 'application/json');
        xmlHttp.send(JSON.stringify(body));
    }
}
